// TYPE
import { RootState } from 'redux/type';
import { AppTourComponent } from 'model';

export const selectEnabledAppTour = (state: RootState): boolean => state.appTourReducer.enabled;
export const selectAppTourComponent = (state: RootState): AppTourComponent | undefined =>
  state.appTourReducer.component;
